import React, {useState, useEffect, useRef} from "react";
import useAxios from "../utils/useAxios";
import {toast} from "react-toastify";
import {CustomModal} from "./CustomModel/CustomModal";
import {useTranslation} from "react-i18next";
import FeatherIcon from "feather-icons-react";
import AccessMenu from "../pages/players/AccessMenu";

const SharePlayerBaseModal = ({isOpen, onClose, endpoint}) => {
    const {t} = useTranslation();
    const api = useAxios();

    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [users, setUsers] = useState([]);
    const [prevQuery, setPrevQuery] = useState("");
    const [sharedUsers, setSharedUsers] = useState([]);

    const [nextPageUrl, setNextPageUrl] = useState(null);
    const [fetchingMore, setFetchingMore] = useState(false);
    const formRef = useRef(null);

    useEffect(() => {
        if (!isOpen) return;
        api.get(endpoint, { params: { limit: 20 } }).then(res => {
            setSharedUsers(res.data.results || []);
            setNextPageUrl(res.data.next ? res.data.next.replace(/^https?:\/\/[^/]+/, '') : null);
        });
    }, [isOpen]);

    useEffect(() => {
        const parent = formRef.current?.parentElement;
        if (!parent) return;

        const handleModalScroll = async (e) => {
            const { scrollTop, scrollHeight, clientHeight } = e.target;
            if (scrollTop + clientHeight >= scrollHeight - 50 && nextPageUrl && !fetchingMore) {
                setFetchingMore(true);
                try {
                    const res = await api.get(nextPageUrl);
                    setSharedUsers(prev => [...prev, ...(res.data.results || [])]);
                    setNextPageUrl(res.data.next ? res.data.next.replace(/^https?:\/\/[^/]+/, '') : null);
                } catch (error) {
                    console.error("Error fetching more users:", error);
                } finally {
                    setFetchingMore(false);
                }
            }
        };

        parent.addEventListener('scroll', handleModalScroll);
        return () => parent.removeEventListener('scroll', handleModalScroll);
    }, [nextPageUrl, fetchingMore]);

    useEffect(() => {
        if (!isOpen) return;
        if (email.length < 2) {
            if (users.length) setUsers([]);
            setPrevQuery("");
            return;
        }

        if (email === prevQuery) return;

        const timer = setTimeout(async () => {
            try {
                setLoading(true);
                const baseId = endpoint.split('/')[5]
                const res = await api.get("api/v1.0/users/search/", {params: {q: email, base: baseId}});
                setUsers(res.data.results || []);
                setPrevQuery(email);
            } catch (e) {
                console.error(e);
            } finally {
                setLoading(false);
            }
        }, 400);

        return () => clearTimeout(timer);
    }, [email, prevQuery, api]);

    const handleSave = async (userId) => {
        try {
            const {data} = await api.post(endpoint, {user: userId, write: false});
            toast.success(t("Access granted"));
            setSharedUsers(prev => [...prev, data]);
            setUsers(prev => prev.filter(u => u.id !== userId));
        } catch {
            toast.error(t("Failed to share"));
        }
    };

    return (
        <CustomModal isOpen={isOpen} onClose={onClose}>
            <form className="modal-form" ref={formRef}>
                <h2>
                    <FeatherIcon icon="user-plus"/> {t("Shared players base access")}
                </h2>

                <div className="form-group" style={{position: "relative"}}>
                    <FeatherIcon
                        icon="search"
                        size={16}
                        className="search-icon"
                    />
                    <input
                        id="client_search"
                        className="search"
                        type="text"
                        placeholder= {t("Search player by email")}
                        // onKeyUp={e => debouncedSearch(e.target.value)}
                        onChange={(e) => setEmail(e.target.value)}
                        style={{ paddingLeft: "30px" }}
                    />

                    {/*<label>{t("Add user")}</label>*/}
                    {/*<input*/}
                    {/*    type="email"*/}
                    {/*    placeholder={t("Enter email")}*/}
                    {/*    value={email}*/}
                    {/*    onChange={(e) => setEmail(e.target.value)}*/}
                    {/*    className="form-control"*/}
                    {/*    autoFocus*/}
                    {/*/>*/}
                </div>

                {/* list of live search result */}
                {users.length > 0 && (
                    <ul className="user-search-results">
                        {users.map(u => (
                            <li key={u.id} onClick={() => handleSave(u.id)}>
                                <div className="user-circle gray">
                                    {`${(u.first_name?.[0] || '')}${(u.last_name?.[0] || '')}`.toUpperCase()}
                                </div>
                                <div className="user-text">
                                    {u.email}
                                    <span>{u.first_name} {u.last_name}</span>
                                </div>
                            </li>
                        ))}
                    </ul>
                )}

                {sharedUsers.length > 0 && (
                    <>
                        <label style={{paddingBottom: "5px"}}>{t("Granted access")}</label>
                        <ul className="user-search-results saved-users">
                            {sharedUsers.map(u => (
                                <li key={u.id} style={{cursor: "default"}}>
                                    <div className={`user-circle ${!u.write ? "gray" : ""}`}>
                                        {`${u.last_name?.[0] || ''}${u.first_name?.[0] || ''}`.toUpperCase()}
                                    </div>
                                    <div className="user-text">
                                        {u.email}
                                        <span>{u.last_name} {u.first_name}</span>
                                    </div>
                                    <div className="right">
                                        <AccessMenu
                                            u={u}
                                            endpoint={endpoint}
                                            setSharedUsers={setSharedUsers}
                                        />
                                    </div>

                                </li>
                            ))}
                        </ul>
                    </>
                )}
                <br/>
            </form>
        </CustomModal>
    );
};

export default SharePlayerBaseModal;
